<template>
    <b-card :title="title">
        <b-card-header >   

            <b-row>
                <b-col class="col-md-8">
                    <b-input v-model="filter" type="search" placeholder="Search review type..."></b-input>
                </b-col>

                <b-col >
                    <slot></slot>
                </b-col>

            </b-row>
        </b-card-header>


        <b-card-body>
        
            <p class="mt-3">
                Page: {{ currentPage }} of {{ Math.ceil(rows/itemsPerPage) }} Total:
                {{  rows}}
            </p>

            <b-table :fields="fields" striped hover responsive :items="items" :per-page="itemsPerPage"
      :current-page="currentPage" :filter="filter">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>

        <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>


    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                {
                    key: 'enforced',
                    label: 'Mandatory',
                    formatter: value => (parseInt(value) ? 'Yes' : 'No'),
                },
                  {
                    key: 'do_release',
                    label: 'Do Release?',
                    formatter: value => (parseInt(value) ? 'Yes' : 'No'),
                },
                'description',
            ],
        }
    },

    mounted() {},

    methods: {},

    computed: {
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        }
       
    },
}
</script>
<style></style>
